import { useCallback, useEffect, useState } from "react";
import useHttpErrorHandler from "src/hooks/useHttpErrorHandler";
import * as Api from "./api";
import {
  IRemyndScrapeCategoryMappingPreviewReq,
  IRemyndScrapeCategoryMappingPreviewResp,
  IRemyndScrapeCategoryMappingRuleFullData
} from "./types";

export type FullDataState = Readonly<{
  fetching: boolean;
  data?: IRemyndScrapeCategoryMappingRuleFullData;
}>;

export const useFullData = () => {
  const { handleError } = useHttpErrorHandler();
  const [state, setState] = useState<FullDataState>({ fetching: false });

  const fetchFullData = useCallback(async () => {
    setState(d => ({ ...d, fetching: true }));
    try {
      const resp = await Api.listFullData();
      setState({ fetching: false, data: resp.value });
    } catch (e) {
      handleError(e);
      setState({ fetching: false, data: undefined });
    }
  }, [handleError]);

  useEffect(() => {
    fetchFullData();
  }, [fetchFullData]);

  return {
    state,
    fetchFullData
  };
};

export type PreviewDataState = Readonly<{
  fetching: boolean;
  data?: IRemyndScrapeCategoryMappingPreviewResp;
}>;

export const usePreviewData = (
  req?: IRemyndScrapeCategoryMappingPreviewReq
) => {
  const { handleError } = useHttpErrorHandler();
  const [state, setState] = useState<PreviewDataState>({ fetching: false });

  const fetchFullData = useCallback(async () => {
    setState(d => ({ ...d, fetching: true }));
    try {
      if (req != null) {
        const resp = await Api.processPreview(req);
        setState({ fetching: false, data: resp.value });
      } else {
        setState({ fetching: false, data: undefined });
      }
    } catch (e) {
      handleError(e);
      setState({ fetching: false, data: undefined });
    }
  }, [req, handleError]);

  useEffect(() => {
    fetchFullData();
  }, [fetchFullData]);

  return {
    state,
    fetchFullData
  };
};
